import React from "react";
import { FormItem } from "@tiny/components";
import { CampaignsInput } from "../../../../../components/ConditionInputs";

interface CampaigsValueProps {
  prefixName: string;
  disabled?: boolean;
}

function CampaigsValue(props: CampaigsValueProps) {
  const { prefixName, disabled } = props;

  const name = `${prefixName}.value.value`;

  return (
    <FormItem
      name={name}
      rules={{
        required: {
          value: true,
          message: "Required field",
        },
      }}
      watchValue
    >
      <CampaignsInput disabled={disabled} />
    </FormItem>
  );
}

export default CampaigsValue;
export { CampaignsInput };
